"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useLotFeatures = function (additionalProperties) {
    var featuresArr = (0, react_1.useMemo)(function () {
        var features = [];
        if (additionalProperties) {
            additionalProperties.forEach(function (x) {
                if (x.name !== '' && x.value !== '' && !x.hidden) {
                    features.push(__assign(__assign({}, x), { key: x.name }));
                }
            });
            features.sort(function (a, b) { var _a, _b; return ((_a = a.order) !== null && _a !== void 0 ? _a : 0) - ((_b = b.order) !== null && _b !== void 0 ? _b : 0); });
        }
        return features;
    }, [additionalProperties]);
    return featuresArr;
};
exports.default = useLotFeatures;
